import React, { useEffect, useState } from 'react';
import ToolsGiornate from './ToolsGiornate';
import axios from 'axios';
import config from '../../config/config.json';
import { Box, CircularProgress, Alert } from '@mui/material';

const host = config.production.host;

const ToolsGiornatePage = () => {
  const [leghe, setLeghe] = useState([]);
  const [stagioni, setStagioni] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const jwt = localStorage.getItem('feathers-jwt');
        const [lResp, sResp] = await Promise.all([
          axios.get(`${host}/tbl-lega`, { headers: { Authorization: `Bearer ${jwt}` }, params: { $limit: 1000, $sort: { nome: 1 } } }),
          axios.get(`${host}/tbl-stagione`, { headers: { Authorization: `Bearer ${jwt}` }, params: { $limit: 1000, $sort: { nome: 1 } } })
        ]);
        setLeghe(lResp.data?.data || []);
        setStagioni(sResp.data?.data || []);
      } catch (err) {
        setError('Errore nel caricamento di leghe o stagioni');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  if (loading) {
    return <Box sx={{ p: 4, textAlign: 'center' }}><CircularProgress /></Box>;
  }
  if (error) {
    return <Box sx={{ p: 4 }}><Alert severity="error">{error}</Alert></Box>;
  }

  return (
    <Box sx={{ maxWidth: 900, mx: 'auto', mt: 4 }}>
      <ToolsGiornate leghe={leghe} stagioni={stagioni} />
    </Box>
  );
};

export default ToolsGiornatePage;
